import React, { useState } from "react";
import { View, Text, ScrollView } from "react-native";
import { Button } from "react-native-paper";
import { MaterialCommunityIcons } from '@expo/vector-icons';
import axios from "axios";
import { FASTAPI_BASE_URL } from "./config";
import { formatLocalDate } from "./Utils";  // adjust the path as needed

const TestResultsSection = ({ isDarkMode, styles, user, activeTest }) => {
  const [testResults, setTestResults] = useState([]);
  const [studentTestResult, setStudentTestResult] = useState(null);

  // Teacher: Fetch all results for a given test.
  const fetchTestResults = async (testId) => {
    try {
      const res = await axios.get(`${FASTAPI_BASE_URL}/tests/${testId}/results`);
      setTestResults(res.data);
    } catch (error) {
      console.error("Error fetching test results:", error);
    }
  };

  // Student: Fetch the latest result for a given test.
  const fetchStudentResult = async (testId) => {
    try {
      const res = await axios.get(
        `${FASTAPI_BASE_URL}/student/${encodeURIComponent(user.email)}/tests/${testId}/result`
      );
      setStudentTestResult(res.data);
    } catch (error) {
      console.error("Error fetching student test result:", error);
    }
  };

  if (!activeTest) return null;

  return (
    <View
      style={{
        marginVertical: 20,
        padding: 10,
        backgroundColor: isDarkMode ? "#222" : "#F5F5F5",
        borderRadius: 10,
      }}
    >
      {user.role === "teacher" ? (
        <>
          <Text style={styles(isDarkMode).sectionTitle}>
            Test Results for {activeTest.title}
          </Text>
          <Button mode="contained" onPress={() => fetchTestResults(activeTest.id)}>
            View Results
          </Button>
          {testResults.length > 0 ? (
            <ScrollView style={{ maxHeight: 300, marginTop: 10 }}>
              {testResults.map((result, idx) => (
                <View
                  key={idx}
                  style={{
                    marginVertical: 5,
                    padding: 10,
                    borderWidth: 1,
                    borderColor: "#ccc",
                    borderRadius: 5,
                  }}
                >
                  <Text>Student: {result.student_email}</Text>
                  <Text>
                    Score: {result.score} / {result.total_score}
                  </Text>
                  <Text>Time Taken: {result.time_taken} seconds</Text>
                  <Text>
                    Submitted On:{" "}
                    {result.completed_at
                      ? formatLocalDate(result.completed_at)
                      : "N/A"}
                  </Text>
                </View>
              ))}
            </ScrollView>
          ) : (
            <Text>No results available.</Text>
          )}
        </>
      ) : (
        <>
          <Text style={styles(isDarkMode).sectionTitle}>
            Your Test Result for {activeTest.title}
          </Text>
          <Button mode="contained" onPress={() => fetchStudentResult(activeTest.id)}>
            View My Result
          </Button>
          {studentTestResult ? (
            <View
              style={{
                marginTop: 10,
                padding: 10,
                borderWidth: 1,
                borderColor: "#ccc",
                borderRadius: 5,
              }}
            >
              <Text>
                Score: {studentTestResult.score} / {studentTestResult.total_score}
              </Text>
              <Text>Time Taken: {studentTestResult.time_taken} seconds</Text>
              <Text>
                 Submitted On:{" "}
                 {studentTestResult.completed_at
                   ? formatLocalDate(studentTestResult.completed_at)
                   : "N/A"}
              </Text>
            </View>
          ) : (
            <Text>No result available.</Text>
          )}
        </>
      )}
    </View>
  );
};

export default TestResultsSection;
